/* Menu Organizations component:
 *      Load the organizations section of the menu, but only if the user opens the
 *      menu and it becomes visible.
 */
define('menu-organizations',['jquery', 'angular', 'vspot-services'], function($, ng) {
    'use strict';

    var menuOrg = ng.module('signup.menuOrganizations', ['vspot.services']);

    menuOrg.component('menuOrganizations', {
        templateUrl: '/script/vspot-angular/components/menu/menu-organizations/menu-organizations.html',
        controller: ['$scope', 'services.Organization', function($scope, Organization) {
            // We need $scope for the $watch functionality
            var ctrl            = this;
            ctrl.loadingOrgs    = false;
            ctrl.showError      = false;
            ctrl.organizations  = [];
            
            // Set up a watch on the menu:
            var stopWatching = $scope.$watch(ng.bind(ctrl, function () {
                return ctrl.menuOpen;
            }), function(newVal, oldVal) {
                if( newVal ) {
                    // User opened the menu
                    if( !ctrl.organizations.length && !ctrl.loadingOrgs ) {
                        // Go ahead and try to load
                        ctrl.showError      = false;
                        ctrl.loadingOrgs    = true;
                        Organization.queryByUser().$promise.then(function(result) {
                            if( result.status ) {
                                // We got the invitations
                                ctrl.organizations = result.data;

                                // Stop watching the menu
                                stopWatching();
                            } else {
                                // We got an error
                                ctrl.showError = true;
                            }

                            // No longer loading
                            ctrl.loadingOrgs = false;
                        });
                    }
                }
            });
        }],
        bindings: {
            menuOpen: '='
        }
    });

});
